/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import PropTypes from 'prop-types'
import { ReactComponent as SvgComponent } from './svg/Info.svg'

export default function Icon__Info({ width, height, className, style, fill }) {
  return (
    <SvgComponent
      width={width}
      height={height}
      className={className}
      style={{ color: fill, ...style }}
    />
  )
}

Icon__Info.displayName = 'Icon__Info'

Icon__Info.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
}

Icon__Info.defaultProps = {
  width: 16,
  height: 16,
  fill: 'rgba(79, 87, 100, 0.87)',
}
